import React, {useEffect, useState } from 'react';
import axios from 'axios';
import '../common/css/imgview.css';

const ImageView = ({fileId})=>  {
  const [images, setImages] = useState("");
  
  useEffect(() => {
    if(fileId)
     {
        
       console.log(fileId);
       console.log('fileId');
       
        axios.get(`/downloadFile?fileId=${fileId}`,{"responseType" : "blob"})
        .then((response) => {
          console.log(response.data);
          const objectURL = URL.createObjectURL(response.data);
          console.log(objectURL);
          setImages(objectURL);
      })
      //   axios.get(`/viewImages?fileId=${fileId}`,{"responseType" : "blob"})
      //  .then((response) => {
      //      console.log(response.data);
      //      let fileRead = new FileReader();
      //      fileRead.readAsDataURL(response.data);
      //      console.log(fileRead.result);
      //      setImages(fileRead.result);
      //  })
     }
 //getFileItems();
   
},[fileId]);  
  // 파일 업로드 핸들러
  

  return (
    <div>
       
      <div style={{marginBottom:'20px',  flexWrap: 'wrap' }}>
        {/* {images.map((image, index) => (
          <div key={index} style={{ margin: '10px' }}>
            <img src={image} alt={`uploaded-${index}`} style={{ width: '150px', height: '150px', objectFit: 'cover' }} />
          </div>
        ))} */}
        <div >
            <img className='imgview_img' src={images} />
          </div>
      </div>
    </div>
  );
};

export default ImageView;